import { useEffect } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

/**
 * This hook addresses an issue in mobile browsers where interacting with
 * select dropdowns (such as year, month, or range/time presets) inside a
 * react-datepicker calendar causes the datepicker to close unintentionally.
 *
 * This fix is based on a known issue in the react-datepicker library:
 * https://github.com/Hacker0x01/react-datepicker/issues/2524
 */
export const usePreventCalendarCloseOnTouch = () => {
  const stopTouchPropagation = useCallbackRef((event: TouchEvent) => {
    event.stopPropagation();
  });

  const handleCalendarOpen = useCallbackRef(() => {
    document.addEventListener('touchstart', stopTouchPropagation, true);
  });

  const handleCalendarClose = useCallbackRef(() => {
    document.removeEventListener('touchstart', stopTouchPropagation, true);
  });

  useEffect(
    () => () => {
      document.removeEventListener('touchstart', stopTouchPropagation, true);
    },
    [stopTouchPropagation],
  );

  return {
    handleCalendarOpen,
    handleCalendarClose,
  };
};
